import { Button } from 'antd';
import { ItalicOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const Italic = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive('italic') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<ItalicOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().toggleItalic().run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="ITALIC" defaultMessage="Italic" />
        </div>
      )}
    </Button>
  );
};

export default Italic;
